import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import SisterConcerns from "../pages/sister-concerns/page";
import Garments from "../pages/sister-concerns/garments/page";
import Accessories from "../pages/sister-concerns/accessories/page";
import PrintingDyeing from "../pages/sister-concerns/printing-dyeing/page";
import Packaging from "../pages/sister-concerns/packaging/page";
import WashingLaundry from "../pages/sister-concerns/washing-laundry/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/sister-concerns",
    element: <SisterConcerns />,
  },
  {
    path: "/sister-concerns/garments",
    element: <Garments />,
  },
  {
    path: "/sister-concerns/accessories",
    element: <Accessories />,
  },
  {
    path: "/sister-concerns/printing-dyeing",
    element: <PrintingDyeing />,
  },
  {
    path: "/sister-concerns/packaging",
    element: <Packaging />,
  },
  {
    path: "/sister-concerns/washing-laundry",
    element: <WashingLaundry />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;